import React from 'react';

import NodeGraph from './NodeGraph';

function UseMemoGraph() {
  return (
    <NodeGraph
      initialState={{
        count: 0,
      }}
      rows={[
        [
          {
            label: 'App',
          },
        ],
        [
          {
            label: 'Counter',
            parentId: 'app',
            ownsState: 'count',
          },
        ],
        [
          {
            label: 'BigCountNumber',
            parentId: 'counter',
            props: ['count'],
            dependsOnState: ['count'],
            isPure: true,
          },
          {
            label: 'Decoration',
            parentId: 'counter',
            dependsOnState: [],
            isPure: true,
          },
        ],
      ]}
    />
  );
}

export default UseMemoGraph;
